import type { Scopes } from '@atlassian/post-office-context';

export const scopes: Scopes = [
	{
		name: 'all',
		when: {
			route: {
				pathname: {
					matches: '.*',
				},
			},
		},
	},
	{
		name: 'admin/all',
		when: {
			context: {
				product: 'admin',
			},
		},
	},
	{
		name: 'admin/products',
		when: {
			context: { product: 'admin' },
			route: {
				pathname: {
					matches: 'atlassian-apps',
				},
			},
		},
	},
	{
		name: 'admin/discovered-products',
		when: {
			context: { product: 'admin' },
			route: {
				pathname: {
					matches: 'shadow-it-apps',
				},
			},
		},
	},
	{
		name: 'admin/domains',
		when: {
			context: { product: 'admin' },
			route: {
				pathname: {
					matches: 'domains',
				},
			},
		},
	},
	{
		name: 'admin/user-requests',
		when: {
			context: { product: 'admin' },
			route: {
				pathname: {
					matches: 'user-requests',
				},
			},
		},
	},
	{
		name: 'admin/user-access-settings',
		when: {
			context: { product: 'admin' },
			route: {
				pathname: {
					matches: 'app-access-settings',
				},
			},
		},
	},
	{
		name: 'admin/authentication-policies',
		when: {
			context: { product: 'admin' },
			route: {
				pathname: {
					matches: 'authentication-policies',
				},
			},
		},
	},
	{
		name: 'admin/users',
		when: {
			context: { product: 'admin' },
			route: {
				pathname: {
					matches: 'users',
				},
			},
		},
	},
	{
		name: 'admin/audit-log',
		when: {
			context: { product: 'admin' },
			route: {
				pathname: {
					matches: 'audit-log',
				},
			},
		},
	},
	{
		name: 'admin/billing-preview',
		when: {
			context: { product: 'admin' },
			route: {
				pathname: {
					matches: 'billing-preview',
				},
			},
		},
	},
	{
		name: 'admin/data-residency',
		when: {
			context: { product: 'admin' },
			route: {
				pathname: {
					matches: 'data-residency',
				},
			},
		},
	},
	{
		name: 'admin/encryption',
		when: {
			context: { product: 'admin' },
			route: {
				pathname: {
					matches: 'encryption',
				},
			},
		},
	},
	{
		name: 'admin/data-security-policies',
		when: {
			context: { product: 'admin' },
			route: {
				pathname: {
					matches: 'data-security-policies',
				},
			},
		},
	},
	{
		name: 'admin/backups',
		when: {
			context: { product: 'admin' },
			route: {
				pathname: {
					matches: 'backups',
				},
			},
		},
	},
	{
		name: 'admin/rovo',
		when: {
			context: { product: 'admin' },
			route: {
				pathname: {
					matches: 'rovo',
				},
			},
		},
	},
	{
		name: 'admin/units',
		when: {
			context: { product: 'admin' },
			route: {
				pathname: {
					matches: 'units',
				},
			},
		},
	},
	{
		name: 'admin/user-access-settings',
		when: {
			context: { product: 'admin' },
			route: {
				pathname: {
					matches: 'user-access-settings',
				},
			},
		},
	},
	{
		name: 'admin/user-connected-apps',
		when: {
			context: { product: 'admin' },
			route: {
				pathname: {
					matches: 'user-connected-apps',
				},
			},
		},
	},
	{
		name: 'admin/changelog',
		when: {
			context: { product: 'admin' },
			route: {
				pathname: {
					matches: 'changelog',
				},
			},
		},
	},
	{
		name: 'admin/product-insights',
		when: {
			context: { product: 'admin' },
			route: {
				pathname: {
					matches: 'product-insights',
				},
			},
		},
	},
	{
		name: 'jira/all',
		when: {
			context: { product: 'jira' },
		},
	},
	{
		name: 'jira/kanban',
		when: {
			context: { product: 'jira' },
			route: {
				pathname: {
					matches: 'board',
				},
			},
		},
	},
	{
		name: 'confluence/all',
		when: {
			context: { product: 'confluence' },
		},
	},
	{
		name: 'confluence/wiki-home',
		when: {
			context: { product: 'confluence' },
			route: {
				pathname: {
					matches: 'wiki/home',
				},
			},
		},
	},
	{
		name: 'confluence/wiki-welcome',
		when: {
			context: { product: 'confluence' },
			route: {
				pathname: {
					matches: 'wiki/welcome',
				},
			},
		},
	},
	{
		name: 'confluence/pages-without-edit',
		when: {
			context: { product: 'confluence' },
			route: {
				pathname: {
					matches: 'wiki/spaces/.*?/pages/(?!edit-v2/).*',
				},
			},
		},
	},
	{
		name: 'confluence/blogs-without-edit',
		when: {
			context: { product: 'confluence' },
			route: {
				pathname: {
					matches: 'wiki/spaces/.*?/blog/(?!edit-v2/).*',
				},
			},
		},
	},
	{
		name: 'confluence/pages',
		when: {
			context: { product: 'confluence' },
			route: {
				pathname: {
					matches: 'wiki/spaces/.*?/pages/.*',
				},
			},
		},
	},
	{
		name: 'confluence/all-content',
		when: {
			context: { product: 'confluence' },
			route: {
				pathname: {
					matches: 'wiki/spaces/.*?/*/.*',
				},
			},
		},
	},
	{
		name: 'confluence/wiki-space-settings',
		when: {
			context: { product: 'confluence' },
			route: {
				pathname: {
					matches: 'wiki/spaces/.+?/settings(/.*)?$',
				},
			},
		},
	},
	{
		name: 'confluence/blogs',
		when: {
			context: { product: 'confluence' },
			route: {
				pathname: {
					matches: 'wiki/spaces/.*?/blog/.*',
				},
			},
		},
	},
	{
		name: 'confluence/all-without-edit',
		when: {
			context: { product: 'confluence' },
			route: {
				pathname: {
					matches: 'wiki/(?!.*/edit-v2/).*',
				},
			},
		},
	},
	{
		name: 'confluence/edit',
		when: {
			context: { product: 'confluence' },
			route: {
				pathname: {
					matches: 'wiki/.*edit.*',
				},
			},
		},
	},
	{
		name: 'confluence/whiteboard',
		when: {
			context: { product: 'confluence' },
			route: {
				pathname: {
					matches: 'wiki/.*whiteboard.*',
				},
			},
		},
	},
	{
		name: 'pop3/all',
		when: {
			context: { product: 'pop3' },
		},
	},
	{
		name: 'pop3/send-it',
		when: {
			context: { product: 'pop3' },
			route: {
				pathname: {
					matches: 'send-it',
				},
			},
		},
	},
	{
		name: 'trello/all',
		when: {
			context: {
				product: 'trello',
			},
		},
	},
	{
		name: 'jira/queue',
		when: {
			context: { product: 'jira' },
			route: {
				pathname: {
					matches: 'queue',
				},
			},
		},
	},
	{
		name: 'jira/browse',
		when: {
			context: { product: 'jira' },
			route: {
				pathname: {
					matches: 'browse',
				},
			},
		},
	},
	{
		name: 'jira/browse/issue',
		when: {
			context: { product: 'jira' },
			route: {
				pathname: {
					matches: 'browse/.*?',
				},
			},
		},
	},
	{
		name: 'jira/issues',
		when: {
			context: { product: 'jira' },
			route: {
				pathname: {
					matches: 'list',
				},
			},
		},
	},
	{
		name: 'jira/itsm/changes-list',
		when: {
			context: { product: 'jira' },
			route: {
				pathname: {
					matches: 'jira/servicedesk/projects/.*?/section/changes/custom/.*?',
				},
			},
		},
	},
	{
		name: 'jira/itsm/changes-list/detail',
		when: {
			context: { product: 'jira' },
			route: {
				pathname: {
					matches: 'jira/servicedesk/projects/.*?/section/changes/custom/.*?/.*?',
				},
			},
		},
	},
	{
		name: 'jira/itsm/risk-insights',
		when: {
			context: { product: 'jira' },
			route: {
				pathname: {
					matches: 'jira/servicedesk/projects/.*?/settings/change-management?tab=risk-insights',
				},
			},
		},
	},
	{
		name: 'jira/itsm/incidents-list',
		when: {
			context: { product: 'jira' },
			route: {
				pathname: {
					matches: 'jira/servicedesk/projects/.*?/section/incidents/custom/.*?',
				},
			},
		},
	},
	{
		name: 'jira/get-started',
		when: {
			context: { product: 'jira' },
			route: {
				pathname: {
					matches: 'jira/get-started',
				},
			},
		},
	},
	{
		name: 'jira/project-issue-navigator',
		when: {
			context: { product: 'jira' },
			route: {
				pathname: {
					matches: 'jira/software(/c)?/projects/.*?/issues(?!.*\\/embed)',
				},
			},
		},
	},
	{
		name: 'projects/selectedissue',
		when: {
			context: { product: 'jira' },
			route: {
				pathname: {
					matches: 'projects',
				},
				search: {
					matches: '.*selectedIssue.*',
				},
			},
		},
	},
	{
		name: 'jira/global-issue-navigator',
		when: {
			context: { product: 'jira' },
			route: {
				pathname: {
					matches: '/issues',
				},
				search: {
					matches: '.*filter.*',
				},
			},
		},
	},
	{
		name: 'jira/issues-full-issue-navigator',
		when: {
			context: { product: 'jira' },
			route: {
				pathname: {
					matches: 'issues',
				},
				search: {
					matches: '.*selectedIssue.*',
				},
			},
		},
	},
	{
		name: 'jira/software',
		when: {
			context: { product: 'jira' },
			route: {
				pathname: {
					matches: 'jira/software',
				},
			},
		},
	},
	{
		name: 'jira/polaris',
		when: {
			context: { product: 'jira' },
			route: {
				pathname: {
					matches: 'jira/polaris',
				},
			},
		},
	},
	{
		name: 'jira/backlog',
		when: {
			context: { product: 'jira' },
			route: {
				pathname: {
					matches: 'backlog',
				},
			},
		},
	},
	{
		name: 'jira/servicedesk',
		when: {
			context: { product: 'jira' },
			route: {
				pathname: {
					matches: 'jira/servicedesk',
				},
			},
		},
	},
	{
		// Jira Plans timeline/list view
		name: 'jira/plan/timeline',
		when: {
			context: { product: 'jira' },
			route: {
				pathname: {
					matches: 'jira/plans/.*/scenarios/.*/timeline',
				},
			},
		},
	},
	{
		// Jira Plans calendar view
		name: 'jira/plan/calendar',
		when: {
			context: { product: 'jira' },
			route: {
				pathname: {
					matches: 'jira/plans/.*/scenarios/.*/calendar',
				},
			},
		},
	},
	{
		// Jira Plans program board
		name: 'jira/plan/program',
		when: {
			context: { product: 'jira' },
			route: {
				pathname: {
					matches: 'jira/plans/.*/scenarios/.*/program',
				},
			},
		},
	},
	{
		// Any pages within Jira Plan
		name: 'jira/plan',
		when: {
			context: { product: 'jira' },
			route: {
				pathname: {
					matches: 'jira/plans/.*/scenarios/.*',
				},
			},
		},
	},
	{
		name: 'jira/project',
		when: {
			context: { product: 'jira' },
			route: {
				pathname: {
					matches: '.*(?=.*project)(?=.*setting).*',
				},
			},
		},
	},
	{
		name: 'jira/your-work',
		when: {
			context: { product: 'jira' },
			route: {
				pathname: {
					matches: '^/issues/?$',
				},
			},
		},
	},
	{
		name: 'jira/ops/alerts',
		when: {
			context: { product: 'jira' },
			route: {
				pathname: {
					matches: 'jira/ops/alerts',
				},
			},
		},
	},
	{
		name: 'jira/ops/alert-details',
		when: {
			context: { product: 'jira' },
			route: {
				pathname: {
					matches: 'jira/ops/alerts/.*?',
				},
			},
		},
	},
	{
		name: 'jira/ops/team/integration',
		when: {
			context: { product: 'jira' },
			route: {
				pathname: {
					matches: 'jira/ops/teams/.*?/integrations/.*?',
				},
			},
		},
	},
	{
		name: 'jira/ops/team-policies',
		when: {
			context: { product: 'jira' },
			route: {
				pathname: {
					matches: 'jira/ops/teams/.*?/policies',
				},
			},
		},
	},
	{
		name: 'jira/ops/group-detail',
		when: {
			context: { product: 'jira' },
			route: {
				pathname: {
					matches: 'jira/ops/group-detail',
				},
			},
		},
	},
	{
		name: 'jira/ops/heartbeats',
		when: {
			context: { product: 'jira' },
			route: {
				pathname: {
					matches: 'jira/ops/teams/.*?/heartbeats',
				},
			},
		},
	},
	{
		name: 'jira/ops/who-is-on-call',
		when: {
			context: { product: 'jira' },
			route: {
				pathname: {
					matches: 'jira/ops/who-is-on-call',
				},
			},
		},
	},
	{
		name: 'jira/ops/team/on-call',
		when: {
			context: { product: 'jira' },
			route: {
				pathname: {
					matches: 'jira/ops/teams/.*?/on-call',
				},
			},
		},
	},
	{
		name: 'jira/ops/alert-notifications',
		when: {
			context: { product: 'jira' },
			route: {
				pathname: {
					matches: 'jira/settings/personal/alert-notifications',
				},
			},
		},
	},
	{
		name: 'jira/settings/products/ops/incoming-call',
		when: {
			context: { product: 'jira' },
			route: {
				pathname: {
					matches: 'jira/settings/products/ops/incoming-call(/.*)?',
				},
			},
		},
	},
	{
		name: 'jira/settings/automation',
		when: {
			context: { product: 'jira' },
			route: {
				pathname: {
					matches: 'settings/automation',
				},
			},
		},
	},
	{
		name: 'jira/for-you',
		when: {
			context: { product: 'jira' },
			route: {
				pathname: {
					matches: 'jira/for-you',
				},
			},
		},
	},
	{
		name: 'jira/servicedesk/settings',
		when: {
			context: { product: 'jira' },
			route: {
				pathname: {
					matches: 'jira/servicedesk/projects/.*/settings(/.*)?',
				},
			},
		},
	},
	{
		name: 'jira/servicedesk/settings/request-types',
		when: {
			context: { product: 'jira' },
			route: {
				pathname: {
					matches: 'jira/servicedesk/projects/.*/settings/request-types(/.*)?',
				},
			},
		},
	},
	{
		name: 'jira/servicedesk/projects/incidents',
		when: {
			context: { product: 'jira' },
			route: {
				pathname: {
					matches: 'jira/servicedesk/projects/.*/section/incidents/custom/.*?/.*?',
				},
			},
		},
	},
	{
		name: 'jira/business/forms/form-directory',
		when: {
			context: { product: 'jira' },
			route: {
				pathname: {
					matches: 'jira/core/projects/.*?/form',
				},
			},
		},
	},
	{
		name: 'jira/business/board',
		when: {
			context: { product: 'jira' },
			route: {
				pathname: {
					matches: 'jira/core/projects/.*?/board',
				},
			},
		},
	},
	{
		name: 'jira/business/timeline',
		when: {
			context: { product: 'jira' },
			route: {
				pathname: {
					matches: 'jira/core/projects/.*/timeline(?!.*\\/embed)',
				},
			},
		},
	},
	{
		name: 'jira/software/forms/form-directory',
		when: {
			context: { product: 'jira' },
			route: {
				pathname: {
					matches: 'jira/software(/c)?/projects/.*?/form',
				},
			},
		},
	},
	{
		name: 'jira/software/cmp/board',
		when: {
			context: { product: 'jira' },
			route: {
				pathname: {
					matches: 'jira/software/c/projects/.*?/boards/[^/]*?$',
				},
			},
		},
	},
	{
		name: 'jira/software/tmp/board',
		when: {
			context: { product: 'jira' },
			route: {
				pathname: {
					matches: 'jira/software/projects/.*?/boards/[^/]*?$',
				},
			},
		},
	},
	{
		name: 'jira/software/cmp/backlog',
		when: {
			context: { product: 'jira' },
			route: {
				pathname: {
					matches: 'jira/software/c/projects/.*?/boards/.*?/backlog',
				},
			},
		},
	},
	{
		name: 'jira/software/tmp/backlog',
		when: {
			context: { product: 'jira' },
			route: {
				pathname: {
					matches: 'jira/software/projects/.*?/boards/.*?/backlog',
				},
			},
		},
	},
	{
		name: 'jira/list-detail-view',
		when: {
			context: { product: 'jira' },
			route: {
				pathname: {
					matches: '.*list.*',
				},
				search: {
					matches: '.*selectedIssue.*',
				},
			},
		},
	},
	{
		name: 'jira/software/list',
		when: {
			context: { product: 'jira' },
			route: {
				pathname: {
					matches: 'jira/software(/c)?/projects/.*?/list',
				},
			},
		},
	},
	{
		name: 'jira/business/list',
		when: {
			context: { product: 'jira' },
			route: {
				pathname: {
					matches: 'jira/core/projects/.*?/list',
				},
			},
		},
	},
	{
		name: 'jira/software/list-project-issue-navigator',
		when: {
			context: { product: 'jira' },
			route: {
				pathname: {
					matches: 'jira/software(/c)?/projects/.*?/list(?!.*\\/embed)',
				},
			},
		},
	},
	{
		name: 'jira/business/list-project-issue-navigator',
		when: {
			context: { product: 'jira' },
			route: {
				pathname: {
					matches: 'jira/core/projects/.*?/list(?!.*\\/embed)',
				},
			},
		},
	},
	{
		// Handles both CMP Software and Business
		name: 'jira/cmp/project-settings/people',
		when: {
			context: { product: 'jira' },
			route: {
				pathname: {
					matches: 'plugins/servlet/project-config/.*?/people',
				},
			},
		},
	},
	{
		name: 'jira/software/tmp/project-settings/access',
		when: {
			context: { product: 'jira' },
			route: {
				pathname: {
					matches: 'jira/software/projects/.*?/settings/access',
				},
			},
		},
	},
	{
		name: 'jira/business/tmp/project-settings/access',
		when: {
			context: { product: 'jira' },
			route: {
				pathname: {
					matches: 'jira/core/projects/.*?/settings/access',
				},
			},
		},
	},
	{
		// Any project route in JSW
		name: 'jira/software/project',
		when: {
			context: { product: 'jira' },
			route: {
				pathname: {
					matches: 'jira/software(/c)?/projects/.*?',
				},
			},
		},
	},
	{
		// Any project settings route in JSW
		name: 'jira/software/project-settings',
		when: {
			context: { product: 'jira' },
			route: {
				pathname: {
					matches: 'jira/software(/c)?/projects/.*?/settings/.*?',
				},
			},
		},
	},
	{
		// Any project route in JWM
		name: 'jira/business/project',
		when: {
			context: { product: 'jira' },
			route: {
				pathname: {
					matches: 'jira/core/projects/.*?',
				},
			},
		},
	},
	{
		// Any project settings route in JWM
		name: 'jira/business/project-settings',
		when: {
			context: { product: 'jira' },
			route: {
				pathname: {
					matches: 'jira/core/projects/.*?/settings/.*?',
				},
			},
		},
	},
	{
		// Project directory
		name: 'jira/projects',
		when: {
			context: { product: 'jira' },
			route: {
				pathname: {
					matches: 'jira/projects',
				},
			},
		},
	},
	{
		name: 'jira/servicedesk/list',
		when: {
			context: { product: 'jira' },
			route: {
				pathname: {
					matches: 'jira/servicedesk/.+?/list',
				},
			},
		},
	},
	{
		name: 'jira/servicedesk/project-summary',
		when: {
			context: { product: 'jira' },
			route: {
				pathname: {
					matches: 'jira/servicedesk/projects/[^/]+/summary',
				},
			},
		},
	},
	{
		name: 'jira/software/board',
		when: {
			context: { product: 'jira' },
			route: {
				pathname: {
					matches: 'jira/software(/[^/]+)?/projects/[^/]+/boards',
				},
			},
		},
	},
	{
		name: 'loom/all',
		when: {
			context: {
				product: 'loom',
			},
		},
	},
	{
		name: 'loom/home',
		when: {
			context: { product: 'loom' },
			route: {
				pathname: {
					matches: 'home',
				},
			},
		},
	},
	{
		name: 'loom/looms/videos',
		when: {
			context: { product: 'loom' },
			route: {
				pathname: {
					matches: 'looms/videos',
				},
			},
		},
	},
	{
		name: 'loom/meetings',
		when: {
			context: { product: 'loom' },
			route: {
				pathname: {
					matches: 'meetings',
				},
			},
		},
	},
	{
		name: 'loom/notifications/all',
		when: {
			context: { product: 'loom' },
			route: {
				pathname: {
					matches: 'notifications/all',
				},
			},
		},
	},
	{
		name: 'loom/watch-later',
		when: {
			context: { product: 'loom' },
			route: {
				pathname: {
					matches: 'watch-later',
				},
			},
		},
	},
	{
		name: 'loom/history',
		when: {
			context: { product: 'loom' },
			route: {
				pathname: {
					matches: 'history',
				},
			},
		},
	},
	{
		name: 'loom/settings/account',
		when: {
			context: { product: 'loom' },
			route: {
				pathname: {
					matches: 'settings/account',
				},
			},
		},
	},
	{
		name: 'loom/settings/workspace',
		when: {
			context: { product: 'loom' },
			route: {
				pathname: {
					matches: 'settings/workspace',
				},
			},
		},
	},
	{
		name: 'jira/business/tmp/project-settings/fields',
		when: {
			context: { product: 'jira' },
			route: {
				pathname: {
					matches: 'jira/core/projects/.*?/settings/fields',
				},
			},
		},
	},
	{
		name: 'jira/software/tmp/project-settings/fields',
		when: {
			context: { product: 'jira' },
			route: {
				pathname: {
					matches: 'jira/software/projects/.*?/settings/fields',
				},
			},
		},
	},
	{
		name: 'jira/software/forms/form-builder',
		when: {
			context: { product: 'jira' },
			route: {
				pathname: {
					matches: 'jira/software(/c)?/projects/.*?/form/.*?/builder',
				},
			},
		},
	},
	{
		name: 'jira/business/forms/form-builder',
		when: {
			context: { product: 'jira' },
			route: {
				pathname: {
					matches: 'jira/core/projects/.*?/form/.*?/builder',
				},
			},
		},
	},
	{
		name: 'jira/software/tmp/project-settings/issue-types',
		when: {
			context: { product: 'jira' },
			route: {
				pathname: {
					matches: 'jira/software/projects/.*?/settings/issuetypes/.*?',
				},
			},
		},
	},
	{
		name: 'jira/business/tmp/project-settings/issue-types',
		when: {
			context: { product: 'jira' },
			route: {
				pathname: {
					matches: 'jira/core/projects/.*?/settings/issuetypes/.*?',
				},
			},
		},
	},
	{
		name: 'jira/software/cmp/project-issue-navigator',
		when: {
			context: { product: 'jira' },
			route: {
				pathname: {
					matches: 'jira/software/c/projects/.*?/issues(?!.*\\/embed)',
				},
			},
		},
	},
	{
		name: 'jira/cmp/project-settings/project-config/issuelayout',
		when: {
			context: { product: 'jira' },
			route: {
				pathname: {
					matches: 'plugins/servlet/project-config/.*?/issuelayout',
				},
			},
		},
	},
	{
		name: 'studio/rovo-agents',
		when: {
			context: {
				product: 'atlassianStudio',
				subproduct: 'rovo-agents',
			},
		},
	},
	{
		name: 'studio/all',
		when: {
			context: {
				product: 'atlassianStudio',
			},
		},
	},
	{
		name: 'cpq',
		when: {
			context: {
				product: 'cpq',
			},
		},
	},
	{
		name: 'welcome/software',
		when: {
			context: {
				product: 'jira',
			},
			route: {
				pathname: {
					matches: 'welcome/software',
				},
			},
		},
	},
	{
		name: 'bitbucket/all',
		when: {
			context: {
				product: 'bitbucket',
			},
		},
	},
	{
		name: 'jira/rovo-search',
		when: {
			context: {
				product: 'jira',
			},
			route: {
				pathname: {
					matches: 'jira/rovo-search',
				},
			},
		},
	},
	{
		name: 'confluence/rovo-search',
		when: {
			context: {
				product: 'confluence',
			},
			route: {
				pathname: {
					matches: 'wiki/search',
				},
			},
		},
	},
];
